// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-43dfd67c]:export{primaryColor:#64b5f6;secondaryColor:#003c60;accentColor:#c41230}.magenta-fill[data-v-43dfd67c]{fill:#f0f!important}.magenta-text[data-v-43dfd67c]{color:#f0f!important}", ""]);
// Exports
module.exports = exports;
